import { required } from 'vuelidate/lib/validators'

export default {
  // falta implementar as validacoes de checkbox dos dias e os campos time
  rule: {
    agenda_id: {
      required
    },
    interval: {
      required
    },
    valid_to_start: {
      required
    },
    valid_to_end: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/form/resources/validations.js